<section>
  <div class="header">
    <h1>{{ 'NOTIFICATION_SETTING.HEADER' | translate }}</h1>
  </div>
  @if (initialized) {
    <form [formGroup]="form" class="row" (ngSubmit)="onSubmit()">
      @for (notificationKind of notificationKinds; track notificationKind) {
        <div
          class="col-12 col-md-6 notification-card-wrapper"
          >
          <article class="notification-card">
            <i class="notification-icon" [ngClass]="notificationKind.icon"></i>
            <section class="notification-content">
              <h6>{{ notificationKind.label | translate }}</h6>
              <p>{{ notificationKind.description | translate }}</p>
            </section>
            <app-toogle
              class="notification-toggle"
              [control]="form.controls[notificationKind.key]"
              [showCaption]="false"
            ></app-toogle>
          </article>
        </div>
      }
      <div class="col-12">
        <br />
        <br />
        <br />
      </div>
      <div class="col-12">
        <button class="btn btn-outlined" type="submit">{{ 'SAVE_BTN' | translate }}</button>
      </div>
    </form>
  }
</section>
